import { render, staticRenderFns } from "./BioBlock.vue?vue&type=template&id=24ee71ce&lang=pug&"
import script from "./BioBlock.vue?vue&type=script&lang=js&"
export * from "./BioBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports